import * as hb from "handlebars/runtime";
import { GlobalFunctions, GlobalVariables } from "./data";
import { Params } from "./data-structures";
declare var brandedSearch: Params;

export class Helpers {
    registerHelpers() {
        var aliasMapping = GlobalVariables.getAliasMapping();
        hb.registerHelper("jobCount", function (currentPage, perPage, lastPage, total) {
            if (total == 0) {
                return "No jobs found";
            } else {
                var start = ((currentPage - 1) * perPage) + 1;
                var end = currentPage == lastPage ? total : currentPage * perPage;
                return "Viewing " + start + " &ndash; " + end + " of " + total + " jobs";
            }
        });

        hb.registerHelper("sort", function (this: any, current, options) {
            var select = $("<select />").html(options.fn(this));
            if (current) select.find('[value="' + current + '"]').attr({ "selected": "selected" });
            return select.html();
        });

        hb.registerHelper("sortdir", function (this: any, current, options) {
            if ($('#sort_attribute').val() === "relevance")
                return;
            else {
                var select = $("<select />").html(options.fn(this));
                if (current) select.find('[value="' + current + '"]').attr({ "selected": "selected" });
                return select.html();
            }
        });

        hb.registerHelper("currentPage", function (this: any, current, compare, options) {
            return current == compare ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("ellipsisBefore", function (this: any, current, total, last, options) {
            return total > 6 && ((current >= 5 && current < last - 4) || ((current >= last - 4 && current <= last && total >= 10))
                || (total < 10 && current >= 5 && current <= last)) ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("ellipsisAfter", function (this: any, current, total, last, options) {
            return total > 6 && (current <= 4 || (current >= 5 && current < last - 4)) ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("lessThanEqualTo", function (this: any, num1, num2, options) {
            return num1 <= num2 ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("for", function (total, current, last, previous, next, block) {
            var list = "";
            if (total > 6) {
                if (current <= 4) {
                    for (var i = 2; i <= 5; i++) {
                        list += block.fn(i);
                    }
                } else if (current >= 5 && current < last - 4) {
                    list += block.fn(previous);
                    list += block.fn(current);
                    list += block.fn(next);
                } else if (current >= last - 4 && current <= last) {
                    for (var i = last - 4; i <= last - 1; i++) {
                        list += block.fn(i);
                    }
                }
            }
            else {
                for (var i = 2; i <= total - 1; i++) {
                    list += block.fn(i);
                }
            }
            return list;
        });

        hb.registerHelper('checked', function (val) {
            return new Handlebars.SafeString(val == 'True' || val == 'true' || val == true ? ' checked="checked"' : '');
        });

        hb.registerHelper('zeroJobs', function (val, alwaysShow) {
            if (brandedSearch && alwaysShow) { return ''; }
            return val == 0 || val == '0' || val == false || val == 'false' || val == undefined ? 'usaj-zero-jobs usajobs-hidden' : '';
        });

        hb.registerHelper('groupDisplay', function (val) {
            return val == true ? '' : 'display:none';
        });

        hb.registerHelper('zeroJobsGroupDisplay', function (val, alwaysShow) {
            if (alwaysShow) { return ''; }
            return val == true ? '' : 'usaj-zero-jobs usajobs-hidden';
        });

        hb.registerHelper('filterIsDisabled', function (isDisabled) {
            return isDisabled ? 'disabled' : '';
        });

        hb.registerHelper("showZeroJobsLink", function (this: any, items, grouped, options) {
            var zeroCount = false;
            var groupCount = grouped ? items.length : 1;
            for (var i = 0; i < groupCount; i++) {
                var filters = grouped ? items[i].Items : items;
                for (var x = 0; x < filters.length; x++) {
                    if (filters[x].AlwaysShow) { return options.inverse(this); }
                    if (filters[x].Count == 0) {
                        zeroCount = true;
                        if (!brandedSearch) {
                            break;
                        }
                    }
                }
                if (!brandedSearch) {
                    if (zeroCount) break;
                }
            }
            if (zeroCount) return options.fn(this);
            else return options.inverse(this);
        });

        hb.registerHelper("showSeriesZeroJobsLink", function (this: any, options) {
            if (brandedSearch && brandedSearch["JobCategoryCode"]) { return options.inverse(this); }
            return options.fn(this);
        });


        hb.registerHelper("alphabetType", function (type) {
            switch (type) {
                case "agencies_alphabet":
                    return "agency";
                case "departments_alphabet":
                    return "department";
            }
        });

        hb.registerHelper("isFedHiringTip", function (this: any, hp, options) {
            return hp == "fed" ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("isVetHiringTip", function (this: any, hp, options) {
            return hp == "vet" ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("isMilitarySpouse", function (this: any, hp, options) {
            return hp == "mspouse" || hp == "military-spouses" ? options.fn(this) : options.inverse(this);
        });

        let hasJobsCounter = 0;
        let totalCounter = 0;
        hb.registerHelper("startNewCounter", function (group) {
            hasJobsCounter = 0;
            totalCounter = 0;
        });

        hb.registerHelper("incrementCounter", function (count) {
            if (count > 0) {
                hasJobsCounter++;
            }
            totalCounter++;
        });

        hb.registerHelper("checkCounter", function (this: any, options) {
            return totalCounter >= 3 ? options.fn(this) : options.inverse(this);
        });

        hb.registerHelper("checkHasJobsCounter", function () {
            return hasJobsCounter < 3 ? 'usaj-zero-jobs usajobs-hidden' : '';
        });

        hb.registerHelper("checkPreferencesActiveState", function (active) {
            return active !== "false" ? "is-active" : "is-inactive";
        });

        hb.registerHelper("checkPreferencesActiveText", function (active) {
            return active !== "false" ? "now" : "no longer";
        });

        hb.registerHelper("hasApplied", function (this: any, id, options) {
            return JSON.parse(sessionStorage.getItem("userObject") ?? "").AppliedJobs.hasOwnProperty(id) ? options.fn(this) : options.inverse(this);
        });
        
        hb.registerHelper("applicationArchived", function (id) {
            return JSON.parse(sessionStorage.getItem("userObject") ?? "").AppliedJobs[id].Archived
                ? "/Applicant/Profile/Dashboard/?c=application-archived" : "/Applicant/Profile/Dashboard";
        });

        hb.registerHelper('insertDash', function (string, insertAtChar) {
            var hypString = string.substr(0, insertAtChar) + '- ' + string.substr(5, string.length - insertAtChar);
            return hypString;
        });
    }
}
